import z from "zod";

import { type ErrorDetails, RemiHttpCode } from "./remi-app";

const pdfRendererErrorTypeValues = ["INVALID_ROUTE_PARAM", "PROPERTY_MODEL_REQUIRED_BUT_MISSING"] as const;

const pdfRendererErrorTypeSchema = z.enum(pdfRendererErrorTypeValues);
const PdfRendererErrorType = pdfRendererErrorTypeSchema.enum;
type PdfRendererErrorType = z.infer<typeof pdfRendererErrorTypeSchema>;

export type PdfRendererErrors =
  | { errorType: typeof PdfRendererErrorType.INVALID_ROUTE_PARAM; data: { param: string; value: string } }
  | { errorType: typeof PdfRendererErrorType.PROPERTY_MODEL_REQUIRED_BUT_MISSING; data: { projectId: number } };

export const pdfRendererErrorDetails: Record<PdfRendererErrorType, ErrorDetails> = {
  [PdfRendererErrorType.INVALID_ROUTE_PARAM]: {
    sentryDescription: "PDF renderer route received an invalid parameter",
    remiHttpCode: RemiHttpCode.BAD_REQUEST,
  },
  [PdfRendererErrorType.PROPERTY_MODEL_REQUIRED_BUT_MISSING]: {
    sentryDescription: "A property model is required for this document but none was found",
    remiHttpCode: RemiHttpCode.BAD_REQUEST,
  },
};
